import {
  BoxForm,
  Col,
  Container,
  ImageBox,
  LogoArea
} from './styled';
import React, { lazy } from 'react';

import { SignUp as AmplifySignUp } from 'aws-amplify-react';
import { Route } from 'react-router-dom';

import style from './style.module.scss';

function SignUpEntry() {
  const NoAuth = lazy(() => import('shared/no-auth'));

  return (
    <Container className={style.login_page__container}>
      {/* <img src={bgBoxes} className={style.background_image} /> */}
      <Col>
        <ImageBox />
        <LogoArea className={style.logo__wrapper}>
          <div className={style.logo} />
        </LogoArea>
      </Col>
      <Col className="form-side">
        <BoxForm>
          <NoAuth />
        </BoxForm>
      </Col>
    </Container>
  );
}

export default class SignUp extends AmplifySignUp {
  showComponent() {
    return (
      <Route
        path="/signup"
        component={SignUpEntry}
      />
    );
  }
}
